import React from "react";
import InquiryTopItem from "./TopItems";
import FormItems from "./FormItems";
import Aux from "../../../hoc/Auxilliary";

function InquiryPage() {
  return (
    <Aux>
      <InquiryTopItem />
      <FormItems />
    </Aux>
  );
}

export default InquiryPage;
